/**
 * Tần suất xuất hiện của từng từ trong KHO ĐỀ THI THẬT của môn:
 * 14 đề FE (420 câu) + 16 đề đọc hiểu + trọn ngân hàng thi nói.
 *
 * SINH TỰ ĐỘNG — đừng sửa tay. Dùng để xếp thứ tự học: người còn ít
 * thời gian chỉ cần học nhóm đầu bảng thay vì cày đủ 231 từ.
 *
 * Từ ngắn 1-2 ký tự bị khớp lồng nhau (本 khớp cả trong 日本語) nên với
 * chúng con số chỉ mang tính tham khảo; từ >=3 ký tự thì chính xác.
 */

export interface VocabFreq { freq: number; rank: number }

export const VOCAB_FREQ: Record<string, VocabFreq> = {
  "～日": { freq: 661, rank: 1 },
  "～時": { freq: 619, rank: 2 },
  "～語": { freq: 393, rank: 3 },
  "～さん": { freq: 364, rank: 4 },
  "～つ": { freq: 348, rank: 5 },
  "来ます": { freq: 287, rank: 6 },
  "します": { freq: 276, rank: 7 },
  "何": { freq: 244, rank: 8 },
  "今": { freq: 234, rank: 9 },
  "～階": { freq: 212, rank: 10 },
  "～屋": { freq: 211, rank: 11 },
  "～歳": { freq: 201, rank: 12 },
  "～円": { freq: 195, rank: 13 },
  "これ": { freq: 183, rank: 14 },
  "どこ": { freq: 168, rank: 15 },
  "教師": { freq: 167, rank: 16 },
  "本": { freq: 151, rank: 17 },
  "～月": { freq: 135, rank: 18 },
  "朝": { freq: 134, rank: 19 },
  "料理": { freq: 129, rank: 20 },
  "行きます": { freq: 126, rank: 21 },
  "見ます": { freq: 114, rank: 22 },
  "休み": { freq: 108, rank: 23 },
  "いつ": { freq: 102, rank: 24 },
  "趣味": { freq: 101, rank: 25 },
  "勉強します": { freq: 100, rank: 26 },
  "～（の）社員": { freq: 93, rank: 27 },
  "会社": { freq: 92, rank: 28 },
  "医者": { freq: 92, rank: 29 },
  "～人": { freq: 91, rank: 30 },
  "日本": { freq: 89, rank: 31 },
  "誰": { freq: 82, rank: 32 },
  "じゃ": { freq: 81, rank: 33 },
  "食べます": { freq: 81, rank: 34 },
  "会社員": { freq: 77, rank: 35 },
  "肉": { freq: 77, rank: 36 },
  "すみません": { freq: 76, rank: 37 },
  "図書館": { freq: 74, rank: 38 },
  "私": { freq: 73, rank: 39 },
  "それ": { freq: 69, rank: 40 },
  "旅行": { freq: 65, rank: 41 },
  "～曜日": { freq: 62, rank: 42 },
  "スーパー": { freq: 59, rank: 43 },
  "毎日": { freq: 59, rank: 44 },
  "日曜日": { freq: 59, rank: 45 },
  "カメラ": { freq: 58, rank: 46 },
  "豚肉": { freq: 57, rank: 47 },
  "どちら": { freq: 56, rank: 48 },
  "音楽": { freq: 56, rank: 49 },
  "いくら": { freq: 56, rank: 50 },
  "ご飯": { freq: 55, rank: 51 },
  "家": { freq: 54, rank: 52 },
  "店員": { freq: 54, rank: 53 },
  "はい": { freq: 52, rank: 54 },
  "こちら": { freq: 52, rank: 55 },
  "土曜日": { freq: 51, rank: 56 },
  "いいえ": { freq: 50, rank: 57 },
  "月曜日": { freq: 50, rank: 58 },
  "大学": { freq: 47, rank: 59 },
  "誕生日": { freq: 47, rank: 60 },
  "サッカー": { freq: 47, rank: 61 },
  "起きます": { freq: 47, rank: 62 },
  "何時": { freq: 46, rank: 63 },
  "買います": { freq: 46, rank: 64 },
  "そこ": { freq: 44, rank: 65 },
  "授業": { freq: 43, rank: 66 },
  "学生": { freq: 42, rank: 67 },
  "そうですか": { freq: 42, rank: 68 },
  "桜": { freq: 42, rank: 69 },
  "カレー": { freq: 42, rank: 70 },
  "鞄": { freq: 41, rank: 71 },
  "読みます": { freq: 41, rank: 72 },
  "英語": { freq: 39, rank: 73 },
  "公園": { freq: 39, rank: 74 },
  "毎朝": { freq: 39, rank: 75 },
  "～分": { freq: 39, rank: 76 },
  "水": { freq: 38, rank: 77 },
  "午前": { freq: 37, rank: 78 },
  "あのう": { freq: 36, rank: 79 },
  "トイレ": { freq: 36, rank: 80 },
  "学校": { freq: 35, rank: 81 },
  "魚": { freq: 35, rank: 82 },
  "とんかつ": { freq: 35, rank: 83 },
  "（お）国": { freq: 34, rank: 84 },
  "ここ": { freq: 34, rank: 85 },
  "携帯（電話）": { freq: 34, rank: 86 },
  "働きます": { freq: 34, rank: 87 },
  "寝ます": { freq: 33, rank: 88 },
  "スープ": { freq: 32, rank: 89 },
  "朝ご飯": { freq: 32, rank: 90 },
  "タイ": { freq: 31, rank: 91 },
  "火曜日": { freq: 31, rank: 92 },
  "オーストラリア": { freq: 30, rank: 93 },
  "（お）仕事": { freq: 30, rank: 94 },
  "ペン": { freq: 30, rank: 95 },
  "水曜日": { freq: 30, rank: 96 },
  "午後": { freq: 29, rank: 97 },
  "あそこ": { freq: 28, rank: 98 },
  "体育館": { freq: 28, rank: 99 },
  "金曜日": { freq: 28, rank: 100 },
  "フランス": { freq: 26, rank: 101 },
  "アルバイト": { freq: 26, rank: 102 },
  "こちらこそ": { freq: 26, rank: 103 },
  "読書": { freq: 26, rank: 104 },
  "レストラン": { freq: 26, rank: 105 },
  "飲みます": { freq: 26, rank: 106 },
  "初めまして": { freq: 24, rank: 107 },
  "えっ": { freq: 24, rank: 108 },
  "ライス": { freq: 24, rank: 109 },
  "ビール": { freq: 24, rank: 110 },
  "木曜日": { freq: 24, rank: 111 },
  "聞きます": { freq: 24, rank: 112 },
  "韓国": { freq: 23, rank: 113 },
  "スポーツ": { freq: 23, rank: 114 },
  "靴": { freq: 23, rank: 115 },
  "時間": { freq: 23, rank: 116 },
  "（お）名前": { freq: 22, rank: 117 },
  "いらっしゃいませ": { freq: 22, rank: 118 },
  "あちら": { freq: 22, rank: 119 },
  "あれ": { freq: 22, rank: 120 },
  "病院": { freq: 22, rank: 121 },
  "財布": { freq: 22, rank: 122 },
  "昼": { freq: 21, rank: 123 },
  "アメリカ": { freq: 20, rank: 124 },
  "新聞": { freq: 20, rank: 125 },
  "卵": { freq: 20, rank: 126 },
  "鶏肉": { freq: 20, rank: 127 },
  "毎晩": { freq: 20, rank: 128 },
  "帰ります": { freq: 20, rank: 129 },
  "郵便局": { freq: 18, rank: 130 },
  "喫煙所": { freq: 17, rank: 131 },
  "冬": { freq: 16, rank: 132 },
  "スキー": { freq: 16, rank: 133 },
  "バーベキュー": { freq: 16, rank: 134 },
  "ホームステイ": { freq: 16, rank: 135 },
  "時計": { freq: 16, rank: 136 },
  "トイレットペーパー": { freq: 16, rank: 137 },
  "ケーキ": { freq: 16, rank: 138 },
  "パン": { freq: 16, rank: 139 },
  "野菜": { freq: 16, rank: 140 },
  "コーヒー": { freq: 16, rank: 141 },
  "（お）弁当": { freq: 16, rank: 142 },
  "ブラジル": { freq: 15, rank: 143 },
  "先生": { freq: 15, rank: 144 },
  "テニス": { freq: 15, rank: 145 },
  "水泳": { freq: 15, rank: 146 },
  "花火": { freq: 14, rank: 147 },
  "何曜日": { freq: 14, rank: 148 },
  "何も": { freq: 13, rank: 149 },
  "パソコン": { freq: 13, rank: 150 },
  "スケジュール": { freq: 13, rank: 151 },
  "へえ": { freq: 12, rank: 152 },
  "（お）花見": { freq: 12, rank: 153 },
  "エスカレーター": { freq: 12, rank: 154 },
  "夜": { freq: 12, rank: 155 },
  "ドイツ": { freq: 11, rank: 156 },
  "日本語学校": { freq: 11, rank: 157 },
  "映画": { freq: 11, rank: 158 },
  "イタリア": { freq: 10, rank: 159 },
  "どうぞ": { freq: 10, rank: 160 },
  "パーティー": { freq: 10, rank: 161 },
  "コンビニ": { freq: 10, rank: 162 },
  "バス": { freq: 10, rank: 163 },
  "テレビ": { freq: 10, rank: 164 },
  "ワイン": { freq: 10, rank: 165 },
  "チーズ": { freq: 10, rank: 166 },
  "昼ご飯": { freq: 9, rank: 167 },
  "夏": { freq: 8, rank: 168 },
  "エレベーター": { freq: 8, rank: 169 },
  "喫茶店": { freq: 8, rank: 170 },
  "銀行": { freq: 8, rank: 171 },
  "海": { freq: 8, rank: 172 },
  "消しゴム": { freq: 8, rank: 173 },
  "ジュース": { freq: 8, rank: 174 },
  "～時半": { freq: 8, rank: 175 },
  "イギリス": { freq: 7, rank: 176 },
  "中国": { freq: 6, rank: 177 },
  "インド": { freq: 6, rank: 178 },
  "いいですね": { freq: 6, rank: 179 },
  "そちら": { freq: 6, rank: 180 },
  "インフォメーション": { freq: 6, rank: 181 },
  "地下": { freq: 6, rank: 182 },
  "注文": { freq: 6, rank: 183 },
  "ズボン": { freq: 6, rank: 184 },
  "イチゴ": { freq: 6, rank: 185 },
  "ハンバーグ": { freq: 6, rank: 186 },
  "紅茶": { freq: 6, rank: 187 },
  "牛乳": { freq: 6, rank: 188 },
  "果物": { freq: 6, rank: 189 },
  "サラダ": { freq: 6, rank: 190 },
  "お酒": { freq: 6, rank: 191 },
  "お寿司": { freq: 6, rank: 192 },
  "テスト": { freq: 4, rank: 193 },
  "あっ": { freq: 4, rank: 194 },
  "秋": { freq: 4, rank: 195 },
  "ゴールデンウィーク": { freq: 4, rank: 196 },
  "（お）祭り": { freq: 4, rank: 197 },
  "レジ": { freq: 4, rank: 198 },
  "電子辞書": { freq: 4, rank: 199 },
  "週末": { freq: 3, rank: 200 },
  "エンジニア": { freq: 2, rank: 201 },
  "一年": { freq: 2, rank: 202 },
  "春": { freq: 2, rank: 203 },
  "インターネット": { freq: 2, rank: 204 },
  "（お）茶": { freq: 2, rank: 205 },
  "ロシア": { freq: 0, rank: 206 },
  "高校": { freq: 0, rank: 207 },
  "看護師": { freq: 0, rank: 208 },
  "デザイナー": { freq: 0, rank: 209 },
  "主婦": { freq: 0, rank: 210 },
  "公務員": { freq: 0, rank: 211 },
  "～ちゃん": { freq: 0, rank: 212 },
  "～君": { freq: 0, rank: 213 },
  "（どうぞ）よろしくお願いします": { freq: 0, rank: 214 },
  "どうもありがとうございます": { freq: 0, rank: 215 },
  "～週間": { freq: 0, rank: 216 },
  "スキーをします": { freq: 0, rank: 217 },
  "このN": { freq: 0, rank: 218 },
  "そのN": { freq: 0, rank: 219 },
  "あのN": { freq: 0, rank: 220 },
  "どこへも": { freq: 0, rank: 221 },
  "ATM": { freq: 0, rank: 222 },
  "100円ショップ": { freq: 0, rank: 223 },
  "Tシャツ": { freq: 0, rank: 224 },
  "スマホ": { freq: 0, rank: 225 },
  "CD": { freq: 0, rank: 226 },
  "DVD": { freq: 0, rank: 227 },
  "油": { freq: 0, rank: 228 },
  "米": { freq: 0, rank: 229 },
  "牛肉": { freq: 0, rank: 230 },
  "リンゴ": { freq: 0, rank: 231 },
};

/** Ngưỡng "hay ra đề": nằm trong 60 từ đầu bảng */
export const HOT_RANK = 60;
